<template>
  <div class="page-annuaire-substance">
    <main class="main">
      <breadcrumbs></breadcrumbs>
      <div class="flex flex-col ">
      <div class="page_title">
        <!-- <status-chip :status="substance.status"></status-chip> -->
        <h1>{{ substance.name }}</h1>
      </div>
      <div v-if="substance.types && substance.types.length" class="-mt-5 mb-2">
          <div v-if="substance.status.class" class="flex -mt-1.5" >
            <status-chip :types="substance.types" :status="substance.status" > </status-chip>
            <dd class="mt-0.5">{{ substance.types.join(', ') }}</dd>
          </div>
          <div v-else>
            <status-type  :types="substance.types" :status="substance.status" > </status-type>
          </div>
        </div>
        </div>

      <div class="main-content">
        <div class="onglets">
          <router-link
            class="onglet"
            v-for="route in routes"
            :key="route.path"
            :to="{ name: route.name }"
          >
            <button>{{ route.meta.label }}</button>
          </router-link>
          <div class="right-elem">
            <button
              v-if="favoriteSubstances.includes(castedId)"
              @click="removeFavorite('substances', castedId)"
              class="btn-fav btn-fav--faved"
            ></button>
            <button
              v-else
              @click="addFavorite('substances', castedId)"
              class="btn-fav btn-fav"
            ></button>
          </div>
        </div>

        <router-view :substance="substance" />

        <div class="last-update">
          Données au :
          {{
            substance.last_phytcom_update
          }}
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Substance from '@/api/substances.js'
import FavoriteMixin from '@/mixins/FavoriteMixin.js'
import StatusChip from '@/components/StatusChip'
import StatusType from '@/components/StatusType'
import Breadcrumbs from '@/components/Breadcrumbs'
import { findRouteChildren } from '@/utils/helpers'
import moment from "moment";

export default {
  name: 'Substance',
  components: { Breadcrumbs, StatusType, StatusChip },
  mixins: [FavoriteMixin],

  props: {
    id: String
  },

  data () {
    return {
      substance: {},
      routes: []
    }
  },

  computed: {
    ...mapState('authent', {
      favoriteSubstances: (state) => state.user?.favorite_substances || []
    }),
    castedId () {
      return Number(this.id)
    }
  },

  created () {
    Substance.retrieve(this.id).then((response) => {
      this.substance = response
    })
    this.updateLastSeen('Substance', this.castedId)

    const currentMatchedRoute = this.$route.matched.slice(-1)[0]
    const parentRoute = currentMatchedRoute.parent
    const substanceRouteChildren = findRouteChildren(
      parentRoute.name,
      this.$router.options.routes
    )

    this.routes = substanceRouteChildren.filter(
      (route) => route.meta && route.meta.label
    )
  },

  methods: {
    format_date(date) {
      moment().locale("fr");
      return moment(date).format("DD/MM/YYYY");
    },
  }
}
</script>
